module.exports = __webpack_public_path__ + "img/logo_footer.d3ae8288.png";